import Reveal from '../components/Reveal';

const steps = [
  {
    number: '1',
    img: '/assets/mascot/mascot-reading.svg',
    alt: 'Reading mascot',
    title: 'Pick Your Letters',
    desc: 'Each level presents a circle of scrambled letters. Study the set and spot the hidden words.',
  },
  {
    number: '2',
    img: '/assets/mascot/mascot-wow.svg',
    alt: 'Wow mascot',
    title: 'Swipe to Form Words',
    desc: 'Draw a path between letters in any direction to spell valid English words from the dictionary.',
  },
  {
    number: '3',
    img: '/assets/mascot/mascot-victory.svg',
    alt: 'Victory mascot',
    title: 'Earn Stars & Coins',
    desc: 'Score 3 stars by finding all required words. Grab bonus words for extra coins and climb the leaderboard.',
  },
];

export default function HowItWorks() {
  return (
    <div className="how-bg" id="how">
      <div className="section">
        <Reveal>
          <p className="section-label">How to Play</p>
          <h2 className="section-title">Simple to Learn, Hard to Put Down</h2>
          <p className="section-sub">Three steps from first launch to word-puzzle obsession.</p>
        </Reveal>
        <Reveal delay={100}>
          <div className="steps-grid">
            {steps.map((step, i) => (
              <>
                <div key={step.number} className="step-card">
                  <div className="step-number">{step.number}</div>
                  <img src={step.img} alt={step.alt} className="step-img" />
                  <div className="step-title">{step.title}</div>
                  <p className="step-desc">{step.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <div key={`arrow-${i}`} className="step-connector">→</div>
                )}
              </>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
